/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class News extends Component {
  state = {
    data: {
      ArTittle: "",
      EnTittle: "",
      KuTittle: "",
      ArDescription: "",
      EnDescription: "",
      KuDescription: "",
      ArBody: "",
      EnBody: "",
      KuBody: "",
      file: null,
    },

    contentHeader: "News List",
    addButtonLabel: "Add News",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetNewsList",
    singleItemUrl: "/api/data/GetNews",
    addUrl: "/api/data/AddNews",
    editUrl: "/api/data/EditNews",
    deleteUrl: "/api/data/DeleteNews",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add News",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit News",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.arabicTitle"),
        field: "AR_TITTLE",
      },
      {
        id: 2,
        label: t("col.englishTitle"),
        field: "EN_TITTLE",
      },
      {
        id: 3,
        label: t("col.kurdishTitle"),
        field: "KU_TITTLE",
      },
      {
        id: 4,
        label: t("col.arabicDescription"),
        field: "AR_DESCRIPTION",
      },
      {
        id: 5,
        label: t("col.englishDescription"),
        field: "EN_DESCRIPTION",
      },
      {
        id: 6,
        label: t("col.kurdishDescription"),
        field: "KU_DESCRIPTION",
      },
      {
        id: 7,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 8,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 9,
        field: "ATTACHMENT",
        label: t("col.attachment"),
        cellRenderer: ({ data }) => {
          return (
            <a href={data.ATTACHMENT} target="blank" style={{ color: "black" }}>
              View File
            </a>
          );
        },
      },
      {
        id: 10,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB52"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB53"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["ArTittle"] = apiResponse.data.respData.data[0].AR_TITTLE;
      data["EnTittle"] = apiResponse.data.respData.data[0].EN_TITTLE;
      data["KuTittle"] = apiResponse.data.respData.data[0].KU_TITTLE;
      data["ArDescription"] = apiResponse.data.respData.data[0].AR_DESCRIPTION;
      data["EnDescription"] = apiResponse.data.respData.data[0].EN_DESCRIPTION;
      data["KuDescription"] = apiResponse.data.respData.data[0].KU_DESCRIPTION;
      data["ArBody"] = apiResponse.data.respData.data[0].AR_BODY;
      data["EnBody"] = apiResponse.data.respData.data[0].EN_BODY;
      data["KuBody"] = apiResponse.data.respData.data[0].KU_BODY;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    const data = new FormData();
    if (this.state.data.file) {
      data.append("File", this.state.data.file, this.state.data.file.name);
    }

    data.append("requestData", JSON.stringify(submitData));

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      data,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.news")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB51"]) && (
              <Button
                label={t("pages.addNews")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "ArTittle",
                label: t("col.arabicTitle"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnTittle",
                label: t("col.englishTitle"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuTittle",
                label: t("col.kurdishTitle"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArDescription",
                label: t("col.arabicDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnDescription",
                label: t("col.englishDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuDescription",
                label: t("col.kurdishDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArBody",
                label: t("col.arabicBody"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnBody",
                label: t("col.englishBody"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuBody",
                label: t("col.kurdishBody"),
                disabled: false,
              },
              {
                type: "fileupload",
                id: "file",
                label: t("col.attachment"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(News);
